import React from 'react';
import type { FC } from 'react';
import type { UserInfo } from '@wix/cli-auth';
import {
  Box,
  ConfirmInput,
  useAsyncCallback,
  Spinner,
  Text,
} from '@wix/cli-ui-kit';
import { logout } from '@wix/cli-auth';
import { match } from 'variant';

interface Props {
  userInfo: UserInfo | null;
}

export const LogoutCommand: FC<Props> = ({ userInfo }) => {
  const logoutAction = useAsyncCallback(logout);

  if (userInfo == null) {
    return <Text>Wix CLI is already logged out</Text>;
  }

  return (
    <>
      <Box marginBottom={1}>
        <Text>When you're logged out you can't use Wix CLI commands.</Text>
      </Box>

      <ConfirmInput
        label={'Continue with logout?'}
        initialValue={true}
        onSubmit={(confirmed) => {
          if (confirmed) {
            void logoutAction.execute();
          }
        }}
      />

      {match(logoutAction.status, {
        NotRequested: () => null,
        Error: () => null,
        Loading: () => <Spinner />,
        Success: () => <Text>Wix CLI is logged out</Text>,
      })}
    </>
  );
};
